import React, { useState, useEffect } from 'react';
import tableHelpers from '../helpers/TableHelpers.js'
import RichTable from '../components/richTable/RichTable.jsx'
import DailyBalanceChart from '../plan/DailyBalanceChart.js';
import AlgoQuickManage from '../manage/AlgoQuickManage.js';
import AlgoDrawer from '../algos/AlgoDrawer.js'
import DatePicker from "react-datepicker"
import AlgoStatsTooltip from '../components/AlgoStatsTooltip.js'
import { getLocalDate } from '../helpers/DateHelpers.js';

function AlgoFinder(props) {

    const [backtestResults, setBacktestResults] = useState({});
    const [chartData, setChartData] = useState([]);
    const [mitigatingAlgos, setMitigatingAlgos] = useState([]);
    const [allocations, setAllocations] = useState([]);
    const [startDate, setStartDate] = useState(props.startDate ? getLocalDate(props.startDate) : new Date(new Date().setMonth(new Date().getMonth() - 1)));
    const [endDate, setEndDate] = useState(props.endDate ? getLocalDate(props.endDate) : new Date());
    const [showAllocatedOnly, setShowAllocatedOnly] = useState(true);
    const [source, setSource] = useState("Backtest");

    useEffect(() => {
        if (props.startDate) {
            setStartDate(getLocalDate(props.startDate));
        }
    }, [props.startDate]);

    useEffect(() => {
        if (props.endDate) {
            setEndDate(getLocalDate(props.endDate));
        }
    }, [props.endDate]);

    useEffect(() => {
        (async function () {
            const url = `/api/lastBacktestResults?planId=` + props.planId + `&liveTradesOnly=` + (source === 'Live Trades' ? '1' : '0');
            let text = await (await fetch(url)).json();
            console.log("backtest", text);
            setBacktestResults(text);

            const tempChartData = [];//[["Date", "Account Value", "S&P 500"]]
            text.dailyResults.forEach(day => tempChartData.push([new Date(day.date), day.total, day.baseline]))
            setChartData(tempChartData)

            let allocationsText = await (await fetch(`/api/algos?planId=` + props.planId + `&years=5`)).json();
            setAllocations(allocationsText);
        })();
    }, [props.planId, source]);

    useEffect(() => {
        (async function () {
            setMitigatingAlgos([]);
            console.log("Loading mitigating algos for date", startDate, endDate);

            const url = `/api/winningAlgoFinder?startDate=` + getDateString(startDate) + `&endDate=` + getDateString(endDate) + (showAllocatedOnly ? `&planId=` + props.planId : "") + `&showLiveTrades=` + (source === 'Live Trades' ? "1" : "0");
            let text = await (await fetch(url)).json();
            console.log("mitigating algos", text);
            if (text && text.success)
                setMitigatingAlgos(text.algos);
        })();
    }, [startDate, endDate, showAllocatedOnly, props.planId, source]);


    function getDateString(date) {
        if (!date) return "";
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }


    function getMitigatingAlgos() {
        let algos = mitigatingAlgos;
        if (showAllocatedOnly) {
            algos = algos.filter(algo => allocations.find(a => a.algoId === algo.algoId && a.percentage > 0));
        }
        return algos.map(algo => {
            return {
                ...algo
            }
        });
    }

    function updateDrawerStartDate(date) {
        setStartDate(date);
    }
    function updateDrawerEndDate(date) {
        setEndDate(date);
    }

    function expandDateRangeByMonth() {
        if (!startDate || !endDate) return;
        const newStart = new Date(startDate);
        newStart.setMonth(newStart.getMonth() - 1);

        let newEnd = new Date(endDate);
        newEnd.setMonth(newEnd.getMonth() + 1);
        const today = new Date();
        if (newEnd > today) {
            newEnd = today;
        }

        setStartDate(newStart);
        setEndDate(newEnd);
    }

    function algoFormatter(cell, row) {
        let allocation = allocations.find(a => a.algoId === row.algoId && a.percentage > 0);
        return (
            <div className='sameline'>
                {allocation ? "🚨" : null}<AlgoDrawer tab="backtesttrades" link={row.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={row.algoId} role={props.role} />
                &nbsp;<AlgoQuickManage role={props.role} algoId={row.algoId} planId={props.planId} />
                &nbsp;<AlgoStatsTooltip algoId={row.algoId} />
            </div>
        );
    }

    return (
        <>
            <div>
                {backtestResults ?
                    <>
                        <br></br>
                        <DailyBalanceChart hideAllocationChart={false} hideOptions={false} hideChartSummary={true} width="100%" startDate={startDate} endDate={endDate} backtestResults={backtestResults} chartData={chartData}></DailyBalanceChart>
                        <br></br>
                        <hr style={{ height: "5px", backgroundColor: 'black' }}></hr>
                    </>
                    :
                    <>Loading...</>
                }

                <div style={{ padding: '20px' }}>
                    <center>
                        Start: <DatePicker className="bg-transparent" selected={startDate} onChange={(date) => updateDrawerStartDate(date)} />
                        &nbsp;End: <DatePicker className="bg-transparent" selected={endDate} onChange={(date) => updateDrawerEndDate(date)} />
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            style={{ fontSize: '12px', padding: '2px 8px', marginLeft: '10px', verticalAlign: 'middle', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                            onClick={expandDateRangeByMonth}
                            title="Expand date range by 1 month in each direction (Start -1 mo, End +1 mo)"
                        >
                            <span>↔</span> ±1 Mo Context
                        </button>
                        &nbsp;&nbsp;<input type="checkbox" checked={showAllocatedOnly} onChange={() => setShowAllocatedOnly(!showAllocatedOnly)} /> Show Allocated Only
                        &nbsp;&nbsp;Source: <select className="bg-transparent" value={source} onChange={(e) => setSource(e.target.value)}>
                            <option value="Backtest">Backtest</option>
                            <option value="Live Trades">Live Trades</option>
                        </select>
                    </center>
                    <RichTable enableExport={true} data={getMitigatingAlgos()} className="table-striped table-hover table-condensed" mappers={
                        [
                            { title: 'Symbol', field: 'trade_symbol', filter: 'choice' },
                            { title: 'Base Symbol', field: 'symbol', filter: 'choice' },
                            { title: 'Algo', field: 'display_name', formatter: algoFormatter, filter: 'text' },
                            { title: 'Profit', field: 'profit', formatter: tableHelpers.percentChangeFormatterOneDecimal, sorters: true },
                            { title: 'Max DD', field: 'max_drawdown', formatter: tableHelpers.percentFormatter, sorters: true },
                            { title: 'Risk:Reward', field: 'risk_reward', formatter: tableHelpers.decimalFormatter, sorters: true },
                            { title: '% Exposure', field: 'percent_in_market', formatter: tableHelpers.percentFormatter, sorters: true },
                            { title: 'Win %', field: 'win_rate', formatter: tableHelpers.percentFormatter, sorters: true },
                            { title: 'Avg P/L', field: 'avg_profit', formatter: tableHelpers.percentChangeFormatterOneDecimal, sorters: true },
                            { title: 'Avg Days', field: 'avg_duration', formatter: tableHelpers.intFormatter, sorters: true },
                            { title: 'Trades', field: 'trade_count', formatter: tableHelpers.intFormatter, sorters: true },
                            { title: 'Type', field: 'algo_type', sorters: true, filter: 'choice' },
                            { title: 'Robustness', field: 'robustness_overall_score', formatter: tableHelpers.decimalFormatter, sorters: true },
                            { title: 'Lookback', field: 'entry_lookback', formatter: tableHelpers.intFormatter, sorters: true },
                        ]
                    } />
                </div>

            </div >
        </>
    );
}

export default AlgoFinder; 